import { render, staticRenderFns } from "./WealthPortfolioWithdraw.vue?vue&type=template&id=f1cfc078&scoped=true&"
import script from "./WealthPortfolioWithdraw.vue?vue&type=script&lang=ts&"
export * from "./WealthPortfolioWithdraw.vue?vue&type=script&lang=ts&"
import style0 from "./WealthPortfolioWithdraw.vue?vue&type=style&index=0&id=f1cfc078&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cfc078",
  null
  
)

export default component.exports